import { FC } from 'react';
import SharedOwnershipLogoPng from './shared-ownership.png';

type SharedOwnershipLogoProps = Omit<JSX.IntrinsicElements['img'], 'src'>;

const SharedOwnershipLogo: FC<SharedOwnershipLogoProps> = (props) => {
    return (
        <img src={SharedOwnershipLogoPng} alt="Shared Ownership" {...props} />
    );
};

export default SharedOwnershipLogo;
